import axios from "axios"
import { toast } from 'react-toastify'
import logout from "./logout"

export const errorHandler = (message) => {
    toast.error(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
    })
}

export const successHandler = (message) => {
    toast.success(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
    })
}

const setHeaders = () => {
    const authObj = {}
    if (localStorage.getItem('token')) authObj.Authorization = localStorage.getItem('token')
    if (localStorage.getItem('tenantId')) authObj["x-tenant-id"] = localStorage.getItem('tenantId')
    if (localStorage.getItem('tenantToken')) authObj['auth-tenant'] = localStorage.getItem('tenantToken')
    return authObj
}


export const GET = async (endpoint) => {
    return new Promise(async function (resolve, reject) {
        try {
            const response = await axios.get(endpoint, { headers: setHeaders() })
            resolve(response);
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token')
                localStorage.removeItem('tenantId')
                localStorage.removeItem('tenantToken')
                window.location.replace(`${process.env.REACT_APP_BASE_URL}/login`)
            } else {
                errorHandler(error.message)
            }
            reject(error);
        }
    });
}

export const POST = async (endpoint, body, label) => {

    return new Promise(async function (resolve, reject) {
        try {
            const response = await axios.post(endpoint, body, { headers: setHeaders() })
            if (label) successHandler(`${label.slice(0, 1).toUpperCase()}${label.slice(1)} added sucessfully`)
            resolve(response)
        } catch (error) {
            console.log(error?.response)
            if (error?.response?.status === 409) errorHandler(error?.response?.data[0]?.message)
            else errorHandler(error.message)
            console.log({ error, label })
            reject(error);
        }
    })
}

export const PUT = async (endpoint, body, label) => {
    return new Promise(async function (resolve, reject) {
        try {
            const response = await axios.put(endpoint, body, { headers: setHeaders() })
            if (label) successHandler(`${label.slice(0, 1).toUpperCase()}${label.slice(1)} updated`)
            resolve(response)
        } catch (error) {
            errorHandler(error.message)
            reject(error);
        }
    })
}

export const DELETE = async (endpoint) => {
    return new Promise(async function (resolve, reject) {
        try {
            const response = await axios.delete(endpoint, { headers: setHeaders() })
            resolve(response);
        } catch (error) {
            errorHandler(error.message)
            reject(error);
        }
    });
}